import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import ReferralType from '../types/ReferralType';

const initialState = {
  legalRepresentative: {},
  company: {},
  termsAndConditions: {},
};

export const Referral = handleActions(
  {
    [ReferralType.actions.updateLegalRepresentative]: (state, { payload: legalRepresentative }) => {
      return { ...state, legalRepresentative: { ...state.legalRepresentative, ...legalRepresentative } };
    },
    [ReferralType.actions.updateCompany]: (state, { payload: company }) => {
      return { ...state, company: { ...state.company, ...company } };
    },
    [ReferralType.actions.updateTermsAndConditions]: (state, { payload: termsAndConditions }) => {
      return { ...state, termsAndConditions: { ...state.termsAndConditions, ...termsAndConditions } };
    },
    [ReferralType.actions.updateAttachedFiles]: (state, { payload: files }) => {
      return { ...state, ...files };
    },
  },
  initialState
);

const getReferral = (state) => state.Referral;

export const getReferralList = (state, list) => {
  const referral = getReferral(state);
  return referral[list] || undefined;
};

export const getLegalRepresentative = createSelector(getReferral, (state) => state.legalRepresentative);
export const getCompany = createSelector(getReferral, (state) => state.company);
export const getTermsAndConditions = createSelector(getReferral, (state) => state.termsAndConditions);
export const getProofOfTaxSituation = createSelector(getReferral, (state) => state.proofOfTaxSituation);
export const getBankCertification = createSelector(getReferral, (state) => state.bankCertification);
export const getClientDocument = createSelector(getReferral, (state) => state.clientDocument);
export const getSocialContract = createSelector(getReferral, (state) => state.socialContract);
export const getOrganizationChart = createSelector(getReferral, (state) => state.organizationChart);
